import createIcon from '@/lib/create-icon'

const TennisIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M40.25 23C40.25 32.5269 32.5269 40.25 23 40.25M40.25 23C40.25 13.4731 32.5269 5.75 23 5.75M40.25 23C30.7231 23 23 15.2769 23 5.75M23 40.25C13.4731 40.25 5.75 32.5269 5.75 23M23 40.25C23 30.7231 15.2769 23 5.75 23M5.75 23C5.75 13.4731 13.4731 5.75 23 5.75'
      stroke='url(#linear-gradient-svg-sports)'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M40.25 23C40.25 32.5269 32.5269 40.25 23 40.25M40.25 23C40.25 13.4731 32.5269 5.75 23 5.75M40.25 23C30.7231 23 23 15.2769 23 5.75M23 40.25C13.4731 40.25 5.75 32.5269 5.75 23M23 40.25C23 30.7231 15.2769 23 5.75 23M5.75 23C5.75 13.4731 13.4731 5.75 23 5.75'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M40.25 23C40.25 32.5269 32.5269 40.25 23 40.25M40.25 23C40.25 13.4731 32.5269 5.75 23 5.75M40.25 23C30.7231 23 23 15.2769 23 5.75M23 40.25C13.4731 40.25 5.75 32.5269 5.75 23M23 40.25C23 30.7231 15.2769 23 5.75 23M5.75 23C5.75 13.4731 13.4731 5.75 23 5.75'
      stroke='url(#radial-gradient-svg-sports)'
      strokeOpacity='0.6'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />

    <defs>
      <linearGradient
        id='linear-gradient-svg-sports'
        x1='5.75'
        y1='5.75'
        x2='45.1888'
        y2='33.1381'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>

      <radialGradient
        id='radial-gradient-svg-sports'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 40.25) scale(17.25 17.5687)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'TennisIcon'
)

export default TennisIcon
